import { ActivityLogFeed } from "@/app/ActivityLogs/Components/ActivityLogFeed";
import { RecordScreenCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenCard";
import { useUserRecord } from "@/app/Users/Hooks/useUserRecord";
import { ModelType } from "@/gql/graphql";

export function UserActivityScreen() {
  const record = useUserRecord();

  return (
    <div className="py-6">
      <RecordScreenCard title="Activity">
        <ActivityLogFeed modelId={record.id} modelType={ModelType.User} />
      </RecordScreenCard>
    </div>
  );
}
